import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, renderSlot as _renderSlot, vModelSelect as _vModelSelect, mergeProps as _mergeProps, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = {
  key: 0,
  value: null,
  disabled: "",
  hidden: ""
}

import { computed } from "vue"

// Ensure data-unit & similar attributes
// are applied to select element
interface Props {
  expanded?: boolean,
  disabled?: boolean,
  multiple?: boolean,
  rounded?: boolean,
  value: string | number | boolean 
    | Object | Array<any> | Function
    | null,
  isDanger?: boolean,
  placeholder: string
}


export default /*#__PURE__*/_defineComponent({
  ...{
  inheritAttrs: false
},
  __name: 'BulmaSelect',
  props: {
    expanded: { type: Boolean },
    disabled: { type: Boolean },
    multiple: { type: Boolean },
    rounded: { type: Boolean },
    value: { type: [String, Number, Boolean, Object, Array, Function, null] },
    isDanger: { type: Boolean },
    placeholder: { default: "" }
  },
  emits: ["input"],
  setup(__props: any, { emit: __emit }) {

/*
 * Intended as replacement for Buefy Select.vue AKA b-select.
 * Uses simpler design than b-select in that there is no support for
 * placeholder option element via a conditional template tag and
 * placeholder prop. Just make use of slot to apply placeholder
 * option along with select-able options.
 * See SettingInput.vue for implementation example.
 */


const props = __props

const emit = __emit

const computedValue = computed({
  get: () => props.value,
  set(updatedValue) {
    emit("input", updatedValue)
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["control", { 'is-expanded': _ctx.expanded }])
  }, [
    _createElementVNode("span", {
      class: _normalizeClass(["select", {
            'is-danger': _ctx.isDanger,
            'is-fullwidth': _ctx.expanded,
            'is-multiple': _ctx.multiple,
            'is-rounded': _ctx.rounded,
            'is-empty': _ctx.value === null
          }])
    }, [
      _withDirectives(_createElementVNode("select", _mergeProps({
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((computedValue).value = $event))
      }, _ctx.$attrs, { disabled: _ctx.disabled }), [
        (_ctx.placeholder)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (computedValue.value == null)
                ? (_openBlock(), _createElementBlock("option", _hoisted_2, _toDisplayString(_ctx.placeholder), 1))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "default")
      ], 16, _hoisted_1), [
        [_vModelSelect, computedValue.value]
      ])
    ], 2)
  ], 2))
}
}

})